import React from 'react';
interface StepsSectionProps {
  language: 'en' | 'es';
}
export function StepsSection({
  language
}: StepsSectionProps) {
  const steps = [{
    num: '01',
    titleEn: 'Private Consultation',
    titleEs: 'Consulta Privada',
    descEn: 'An in-depth analysis of your current financial standing and future aspirations.',
    descEs: 'Un análisis profundo de su situación financiera actual y aspiraciones futuras.'
  }, {
    num: '02',
    titleEn: 'Custom Strategy',
    titleEs: 'Estrategia Personalizada',
    descEn: 'We design a bespoke portfolio of tax and insurance solutions tailored to your needs.',
    descEs: 'Diseñamos un portafolio a medida de soluciones fiscales y de seguros adaptadas a sus necesidades.'
  }, {
    num: '03',
    titleEn: 'Execution & Growth',
    titleEs: 'Ejecución y Crecimiento',
    descEn: 'Seamless implementation with ongoing VIP support to ensure your legacy thrives.',
    descEs: 'Implementación impecable con soporte VIP continuo para asegurar que su legado prospere.'
  }];
  return <section id="process" className="py-24 bg-luxury-alt relative" data-id="element-278">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-280">
          <h2 className="font-sans text-sm font-bold text-gold-light tracking-[0.2em] uppercase mb-4" data-id="element-281">
            {language === 'en' ? 'Our Process' : 'Nuestro Proceso'}
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-warm-white mb-6" data-id="element-282">
            {language === 'en' ? 'The Path to Security' : 'El Camino hacia la Seguridad'}
          </h3>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-283">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-gold-primary/50 to-transparent" data-id="element-284" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-285">
            {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center group" data-id="element-286">
                {/* Number Badge */}
                <div className="w-24 h-24 rounded-full bg-luxury-card border border-gold-primary/30 flex items-center justify-center mb-8 relative z-10 group-hover:border-gold-primary group-hover:shadow-gold-glow transition-all duration-500" data-id="element-287">
                  <div className="absolute inset-2 rounded-full border border-dashed border-gold-dark/40 group-hover:rotate-180 transition-transform duration-1000" data-id="element-288" />
                  <span className="font-serif text-3xl font-bold text-gradient-gold" data-id="element-289">
                    {step.num}
                  </span>
                </div>

                {/* Diamond separator */}
                <div className="text-gold-primary/50 text-[10px] mb-6" data-id="element-290">◆</div>

                <h4 className="font-serif text-2xl text-warm-white mb-4" data-id="element-291">
                  {language === 'en' ? step.titleEn : step.titleEs}
                </h4>
                <p className="text-warm-gray leading-relaxed" data-id="element-292">
                  {language === 'en' ? step.descEn : step.descEs}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}